// Copied from fox-forms codegen (and fox-seeourm) work/@fox/codegen/forms.ts

// Inlined to avoid @fox/atoms import because survey-next-frontend is importing this too and we
// can't be importing potentially frontend code from SNF!
function toTitleCase(str: string) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

//At this point in time, this is separate to OwnerType. They will eventually be merged.
export enum EntityType {
	Address = 'ADDRESS',
	CallList = 'CALL_LIST',
	Contact = 'CONTACT',
	Deleted = 'DELETED',
	Event = 'EVENT',
	FormResponse = 'FORM_RESPONSE',
	Invoice = 'INVOICE',
	List = 'LIST',
	Organization = 'ORGANIZATION',
	Person = 'PERSON',
	Receipt = 'RECEIPT',
	Relationship = 'RELATIONSHIP',
	Subscription = 'SUBSCRIPTION',
	TestOnlyA = 'TEST_ONLY_A',
	TestOnlyB = 'TEST_ONLY_B',
	Ticket = 'TICKET',
	Unmapped = 'UNMAPPED',
	User = 'USER',
	VisitList = 'VISIT_LIST'
}

export function stringToEntityType(str: string): EntityType {
	if (!str) return EntityType.Unmapped;
	switch (str.toUpperCase()) {
		case 'PERSON':
			return EntityType.Person;
		case 'ORGANIZATION':
		case 'ORGANISATION':
			return EntityType.Organization;
		case 'USER':
			return EntityType.User;
		case 'ADDRESS':
			return EntityType.Address;
		//TODO: deal with all other EntityTypes
		default:
			return EntityType.Unmapped;
	}
}

export function entityTypeToString(entityType?: EntityType): string {
	if (!entityType) return '';
	return entityType.split('_').map(toTitleCase).join(' ');
}
